import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const fetchProjDetails = async ({ queryKey }) => {
  const { selectedProj, access_token, token_type } = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/${selectedProj["Project ID"]}`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });

  return response.data;
}

export const fetchProjects = async ({ queryKey }) => {
  const { token_type, access_token } = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  // console.log('resoponse from Organisations RQ', response);
  return response.data;
}

export const fetchProjectData = async ({ queryKey }) => {
  const { selectedProj, access_token, token_type } = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/${selectedProj["Proj ID"]}`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });

  return response.data;
}

export const fetchUserProjects = async ({ queryKey }) => {
  const { access_token, token_type, organisationId } = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/?org_id=${organisationId}`,
    method: "GET",
    // data: {org_id_list: [organisationId]},
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  // console.log('resoponse from Organisations RQ', response);
  return response.data;
}

export const getProjUsers = async ({ queryKey }) => {
  const { orgId, access_token, token_type } = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/${orgId}/users`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });

  return response.data;
}

export const getProjExistingUsers = async ({ queryKey }) => {
  const { selectedProj, access_token, token_type } = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/${selectedProj["Project ID"]}/users`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });

  return response.data;
}

export const createNewProject = async ({ proj, access_token, token_type, orgId }) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/?org_id=${orgId}`,
    method: "POST",
    data: proj,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });

  return response.data;
}

export const updateProject = async ({ selectedProj, payload, access_token, token_type }) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/${selectedProj["Project ID"]}?org_id=${selectedProj["Org ID"]}`,
    method: "POST",
    data: payload,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    }
  });

  return response.data;
}
export const projectSettings = async ({ selectedProj, payload, access_token, token_type }) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/setting/`,
    method: "POST",
    data: payload,
    // data: { ...payload, 'org-id': selectedProj["Org ID"], 'proj-id': selectedProj["Project ID"] },
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `${token_type} ${access_token}`,
      'org-id': selectedProj["Org ID"], // Pass org_id in headers
      'proj-id': selectedProj["Project ID"] // Pass proj_id in headers
    }
  });
  return response.data;
};
export const getprojectSettings = async ({ selectedProj, payload, access_token, token_type }) => {
  console.log(selectedProj, payload,)
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/setting/`,
    method: "GET",
    data: payload,
    // data: { ...payload, 'org-id': selectedProj["Org ID"], 'proj-id': selectedProj["Project ID"] },
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `${token_type} ${access_token}`,
      'org-id': selectedProj["Org ID"], // Pass org_id in headers
      'proj-id': selectedProj["Project ID"] // Pass proj_id in headers
    }
  });
  return response.data;
};